import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { STORAGE_KEY } from './constants';
export var getRememberedAccounts = function getRememberedAccounts() {
  try {
    var accounts = window.localStorage.getItem(STORAGE_KEY);

    if (!accounts) {
      return [];
    }

    return JSON.parse(accounts);
  } catch (error) {
    return [];
  }
};
export var saveAccount = function saveAccount(account) {
  try {
    var rememberedAccounts = getRememberedAccounts();
    var preparedAccounts = rememberedAccounts.filter(function (_ref) {
      var value = _ref.value;
      return value !== account.value;
    });
    var accounts = [account].concat(_toConsumableArray(preparedAccounts));
    var value = JSON.stringify(accounts);
    window.localStorage.setItem(STORAGE_KEY, value);
    return accounts;
  } catch (error) {
    return [];
  }
};
export var deleteRememberedAccount = function deleteRememberedAccount(account) {
  try {
    var rememberedAccounts = getRememberedAccounts();
    var accounts = rememberedAccounts.filter(function (_ref2) {
      var value = _ref2.value;
      return value !== account.value;
    });
    var value = JSON.stringify(accounts);
    window.localStorage.setItem(STORAGE_KEY, value);
    return accounts;
  } catch (error) {
    return [];
  }
};
export var deleteAllRememberedAccounts = function deleteAllRememberedAccounts() {
  window.localStorage.removeItem(STORAGE_KEY);
};